export class MobileHelper {

    public static isMobileDevice(): boolean {
        return (new RegExp('Android|webOS|iPhone|iPad|' +
            'BlackBerry|Windows Phone|' +
            'Opera Mini|IEMobile|Mobile',
            'i')).test(navigator.userAgent);
    }

    public static isAppleDevice(): boolean {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) &&
            !window["MSStream"];
    }

    public static getScrollParent(element, includeHidden) {
        try {
            let style = getComputedStyle(element);
            const excludeStaticParent = style.position === "absolute";
            const overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

            if (style.position === "fixed") return document.body;

            let parent = element;
            do {
                style = getComputedStyle(parent);
                if (excludeStaticParent && style.position === "static") {
                    continue;
                }
                if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
                parent = parent.parentElement;
            } while (parent != null)

            return document.body;
        } catch (e) {
            return null;
        }
    }
}
